module.exports = __webpack_public_path__ + "static/media/colori.151bbca7.png";